export const formStyles = {
  section: {
    '& > *': { mb: '16px !important' },
  },
};
